function BeforePPNKontrak(detailOrder: any, quantum: any, price: any) {
  let total = 0
  detailOrder.forEach((item: any, index: any) => {
    total += quantum[index] * price[index]
  })
  return total
}

function AfterPPNKontrak(detailOrder: any, quantum: any, price: any) {
  let total = 0
  detailOrder.forEach((item: any, index: any) => {
    // console.log(detailOrder[0].ppn)
    total +=
      quantum[index] * (price[index] + (price[index] / 100) * detailOrder[0].ppn) -
      ((quantum[index] * (price[index] + (price[index] / 100) * detailOrder[0].ppn)) /
        ((detailOrder[0].ppn + 100) / 100) /
        100) *
        0
  })
  return total
}

export {BeforePPNKontrak, AfterPPNKontrak}
